module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      articlePicker: true, flipToggle: true, active: _vm.active
    }
  }, [_c('div', {
    staticClass: "filterPanel"
  }, [_c('div', {
    class: {
      filterButton: true, disabled: _vm.currentArticleSorting != 'all'
    },
    on: {
      "click": _vm.toggleFilter
    }
  }, [(!_vm.filterActive) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('showFilter')) + "  "), _c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.filterActive) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('hideFilter')) + "  "), _c('i', {
    staticClass: "icon-close bold"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filterButton sortButton"
  }, [_c('div', {
    staticClass: "currentSorting",
    on: {
      "click": function($event) {
        _vm.sortingActive = !_vm.sortingActive
      }
    }
  }, [(_vm.currentArticleSorting == 'all') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('allProducts')) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "listing articleList",
    attrs: {
      "id": "articleScroller"
    },
    on: {
      "scroll": _vm.checkLazy
    }
  }, [(_vm.chosenFilters && _vm.currentArticleSorting == 'all') ? _c('div', {
    staticClass: "filterChoices"
  }, _vm._l((_vm.chosenFilters), function(filter) {
    return _c('div', {
      staticClass: "chosenFilter hover-fade",
      on: {
        "click": function($event) {
          _vm.removeFilterChoice(filter)
        }
      }
    }, [_vm._v(" \n\t\t\t \t" + _vm._s(filter.title) + "\n\t\t\t")])
  })) : _vm._e(), _vm._v(" "), (_vm.articles) ? _c('div', [(_vm.currentArticleSorting == 'favorites') ? _c('div', {
    staticClass: "favMatch"
  }, [(_vm.device.isMobile) ? _c('span', [_vm._v("\n  \t\t\t\t\t" + _vm._s(_vm.$t('favoritesThatMatchMobile')) + "\n  \t\t\t\t")]) : _c('span', [_vm._v("\n  \t\t\t\t\t" + _vm._s(_vm.$t('favoritesThatMatch')) + "\n  \t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.articles), function(item) {
    return (_vm.filterOutUnwantedArticles(item)) ? _c('div', {
      staticClass: "item small-full medium-half large-third smooth"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "imgInner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(item)
      }
    })])]), _vm._v(" "), _c('div', {
      class: {
        tags: true, active: _vm.articleHasCampaign(item)
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.campaignBadge))])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.price) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    class: {
      lazyLoading: true, active: !_vm.lazyDone
    }
  }, [_c('loader', {
    attrs: {
      "loading": true
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.articles && _vm.noArticles && !_vm.loading) ? _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('noArticlesMatched', {
        size: _vm.currentSize
      }))
    }
  }) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d9b670a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Picker/ArticlePicker.vue
// module id = 161
// module chunks = 0